<template>
  <div class="dot-steps">
    <ul>
      <li v-for="(item, index) in menuSteps"
          :key="index"
          :class="{'active': (!index && item.active) ||
          (item.active && index && !menuSteps[index - 1].active)}">
        <div class="dot"/>
        <a href="#"
            @click.prevent.stop="scrollToView(item.ref)">{{ item.name }}</a>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'dots-menu',
  props: ['steps'],
  data() {
    return {
      menuSteps: [],
    };
  },
  methods: {
    initSteps() {
      this.steps.forEach(step => {
        if (document.querySelector(step.ref)) {
          document.querySelector('.is-main-content').addEventListener('scroll', () => {
            if (this.isInViewport(step.ref)) {
              step.active = true;
            } else {
              step.active = false;
            }
          });
          this.menuSteps.push(step);
        }
      });
    },
    scrollToView(id) {
      const coord = document.querySelector(id).getBoundingClientRect();
      // on retire 150 pour l'entete => voir lors de la mise en
      // place des graphic pour ne pas mettre une valeur en dur
      const top = coord.top - 150;
      const scrollOptions = {
        left: 0,
        top: top,
        behavior: 'smooth',
      };
      document.querySelector('.is-main-content').scrollBy(scrollOptions);
    },
    isInViewport(element) {
      const elem = document.querySelector(element);
      if (!elem) {
        return false;
      }
      const bounding = elem.getBoundingClientRect();

      const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
      const windowWidth = (window.innerWidth || document.documentElement.clientWidth);

      const vertInView = (bounding.top > 80 || bounding.top < 80 && bounding.bottom > windowHeight);
      const horInView = (bounding.left <= windowWidth) && ((bounding.left + bounding.width) >= 0);

      return (vertInView && horInView);
    },
  },
  mounted() {
    this.initSteps();
  },
};
</script>
